import React from 'react';

/**
 * Reusable stat card for the admin dashboard top strip.
 */
const StatCard = ({ label, value }) => (
  <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm">
    <div className="text-xs tracking-[0.2em] uppercase font-bold text-slate-600 mb-2">
      {label}
    </div>
    <div className="text-3xl font-black text-slate-900">{value}</div>
  </div>
);

export default React.memo(StatCard);
